import BaseModel from '../core/BaseModel'
export default class RoleModel extends BaseModel {
    constructor() {
        super({ 
                name: "roles",
                tableName: 'core_role'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Tên quyền truy cập',
                sortable: true,
                filter: { type: 'input',match: 'custom', placeHolder: 'Nhập tên phân quyền'}
            },
            is_management_lower_level: {
                name: 'is_management_lower_level',display: false, label: 'Quản lý dữ liệu cấp dưới', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 15, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            status: {
                name: 'status', label: 'Đại lý phân quyền', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 15, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            description: { 
                name: 'description', 
                type: "String", 
                label: 'Mô tả',
                display: false
            },
            fied_detail: {
                refs: ' role_access_id ',
                display: false
            },
        },)
    }

}